import { styled } from "@linaria/react"

import { Horizontal } from "@/components/Flex.ts"

import type { Ref } from "react"


export const DotsProgress = (props: {
  ref: Ref<HTMLDivElement>
}) => {
  return (
    <Horizontal gap="2px" ref={props.ref}>
      <Circle1 />
      <Circle2 />
      <Circle3 />
    </Horizontal>
  )
}

const Circle = styled.div`
  width: 3px;
  min-width: 3px;

  height: 3px;
  min-height: 3px;

  background-color: var(--secondary-text-color);
  border-radius: var(--border-radius-round);
`

const Circle1 = styled(Circle)`
  @keyframes circle1 {
    20% {
      transform: translate(0, -6px)
    }

    40% {
      transform: translate(0, 0)
    }
  }

  animation: circle1 1.5s ease-in-out 0.495s infinite;
`

const Circle2 = styled(Circle)`
  @keyframes circle2 {
    20% {
      transform: translate(0, -6px)
    }

    40% {
      transform: translate(0, 0)
    }
  }

  animation: circle2 1.5s ease-in-out 0.57s infinite;
`

const Circle3 = styled(Circle)`
  @keyframes circle3 {
    20% {
      transform: translate(0, -6px)
    }

    40% {
      transform: translate(0, 0)
    }
  }

  animation: circle3 1.5s ease-in-out 0.645s infinite;
`
